import type { ShuffleInspector } from './types';
import type { ActivityDTO } from 'src/types/dto/activity.dto';
import type { AppointmentDTO } from 'src/types/dto/appointment.dto';

import { getEarliestActivityAppointment } from './get-earliest-appointment';

export const getCurrentActivityInspector = (
  currentActivity: ActivityDTO,
  appointment?: AppointmentDTO
): ShuffleInspector | null => {
  const inspector =
    appointment?.inspector ??
    currentActivity.allocatedInspectors?.[0] ??
    getEarliestActivityAppointment(currentActivity.appointments)?.inspector;

  if (!inspector?.id) {
    return null;
  }

  return {
    id: inspector.id,
    name: inspector.name,
  };
};
